import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Box } from 'grommet';

const StyledBox = styled(Box)`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: calc(100vh - 94px);
  z-index: 8;
  background: repeating-linear-gradient(
    -55deg,
    #e6e6e6,
    #e6e6e6 10px,
    #e9e9e9 10px,
    #e9e9e9 20px
  );
  @media (max-width: 600px) {
    height: calc(100vh - 74px);
  }
`;

const ScrollableBox = styled.div`
  overflow-y: auto;
`;

function MenuPane({ children }) {
  return (
    <StyledBox
      direction="column"
      width="large"
      elevation="small"
      pad={{ left: 'medium', top: 'medium', bottom: 'xxsmall' }}
    >
      <ScrollableBox>
        <Box pad={{ right: 'medium' }}>{children}</Box>
      </ScrollableBox>
    </StyledBox>
  );
}

export default inject('AppState')(observer(MenuPane));



// WEBPACK FOOTER //
// ./src/app/components/Menu/MenuPane.js